module.exports = __webpack_public_path__ + "static/img/csi2.d0512751.png";